import { Credit } from '@/services/api';

export enum UpgradeReason {
    CREDITS = 'credits',
    SUBTITLES = 'subtitles',
    PREMIUM_VOICE = 'premium-voice',
    NONE = 'none',
}

export const isMissingCredits = (userCredits: Credit | undefined, creditsCost: number | null) =>
    !!(!userCredits?.remaining || (creditsCost && userCredits?.remaining < creditsCost));

export const getUpgradeReason = (
    isPremiumUser: boolean,
    subtitlesEnabled: boolean,
    creditsCost: number | null,
    userCredits?: Credit,
    usesPremiumVoice?: boolean
) => {
    if (isMissingCredits(userCredits, creditsCost)) {
        return UpgradeReason.CREDITS;
    }
    if (!isPremiumUser && usesPremiumVoice) {
        return UpgradeReason.PREMIUM_VOICE;
    }
    if (!isPremiumUser && subtitlesEnabled) {
        return UpgradeReason.SUBTITLES;
    }

    return UpgradeReason.NONE;
};
